import { observer } from "mobx-react";
import React from "react";
import { ImageTypeEnum } from "../../../../constants/enums/image-type-enum";

const AgreementImageCard = (props: any) => {
  const {
    id,
    index,
    images,
    handleDeleteImage,
    handleShowPreview,
    viewOnly,
    children,
    imageType,
    className
  } = props;

  const imageUrl = index === -1 ? images[0] : images[index];

  return (
    <div
      key={id}
      className={`image-card-container ${className ? className : ""}`}
    >
      {imageUrl ? (
        <>
          <img
            src={imageUrl}
            alt={`image ${index + 1}`}
            className="image-card-img"
          />
          <div className="image-card-overlay">
            {/* Eye icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              width="20"
              height="20"
              className="image-card-icon"
              onClick={() => handleShowPreview(index, imageType)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            {/* Pencil icon */}
            {
              !viewOnly &&
              <>
                {/* Trash icon */}
                {
                  handleDeleteImage &&
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="white"
                    width="20"
                    height="20"
                    className="image-card-icon"
                    onClick={() => handleDeleteImage(index, imageType)}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                }
              </>
            }
          </div>
        </>
      ) : (
        <span className="image-card-placeholder">{children}</span>
      )}
    </div>
  );
};

interface AgreementImageCardDnDProps {
  id: string;
  type: string;
  className: string;
  index: number;
  images: string[];
  handleDeleteImage?: (indexToDelete: number) => void;
  handleShowPreview: (index: number, imageType: ImageTypeEnum) => void;
  viewOnly:boolean;
  children?: any;
  imageType: ImageTypeEnum;
}


const AgreementImageCardDnD: React.FC<AgreementImageCardDnDProps> = ({
  id,
  type,
  index,
  images,
  handleDeleteImage,
  handleShowPreview,
  viewOnly = false,
  children,
  imageType,
  className
}) => {

  return (
    <div style={{ opacity: 1 }}>
      <AgreementImageCard
        id={id}
        index={index}
        images={images}
        handleDeleteImage={handleDeleteImage}
        handleShowPreview={handleShowPreview}
        viewOnly={viewOnly}
        imageType={imageType}
        className={className}
      >
        {children || "Empty"}
      </AgreementImageCard>
    </div>
  );
};

export default observer(AgreementImageCardDnD);

// export default ImageCard;
